import React from 'react';
import { Arrow } from '../../../../../../../static/icons/arrow';
import { Stack } from '../../../../../atoms/stack/Stack';
import { Row } from '../../../../../atoms/row/Row';
import { Typography } from '../../../../../atoms/typography/Typography';
import { LinkButton } from '../../../../../atoms/linkButton/LinkButton';

const CategoriesMobileList = ({ categories, backAction, t }) => (
  <Stack className="w-full">
    <Row className="items-center global-hover pl-3" onClick={backAction}>
      <span>
        <Arrow color="black" height={20} width={20} />
      </span>
      <Typography
        fontVariant="lg"
        textTransform="uppercase"
        className="flex-1 font-bold"
        textAlign="left"
      >
        {t('common.back')}
      </Typography>
    </Row>
    {categories.menuItems.map((sub) => (
      <Stack key={`MobileMenuCat-${sub.id}`}>
        <LinkButton
          className="text-clamp-lg w-fit font-bold !text-customGray-900"
          variant="transparent"
          label={sub.title}
          href={sub.href}
        />
        {sub.menuItems &&
          sub.menuItems.map((el) => (
            <LinkButton
              key={`MobileMenuSubCat-${el.id}`}
              className={
                'w-fit pl-7 text-clamp-lg !text-customGray-600 before:content-["›"] before:inline-block before:w-2'
              }
              variant="transparent"
              label={el.title}
              href={el.href}
            />
          ))}
      </Stack>
    ))}

    {categories.footers?.map((footer) => (
      <span className="border-y py-2 mt-2">
        <LinkButton
          key={footer.id}
          href={footer.href}
          className="w-full text-clamp-lg font-bold !text-customGray-900 underline"
          variant="transparent"
          label={footer.text}
        />
      </span>
    ))}
  </Stack>
);

export default CategoriesMobileList;
